export { default } from './CssBaseline';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/CssBaseline/index.js
// module id = 538
// module chunks = 2